import { MouseEvent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDownAZ } from '@fortawesome/free-solid-svg-icons/faArrowDownAZ';
import { faArrowUpZA } from '@fortawesome/free-solid-svg-icons/faArrowUpZA';
import { faXmark } from '@fortawesome/free-solid-svg-icons/faXmark';
import { FilterValue } from 'components/filtering/types/FilterObject';
import { SortModeEnum } from 'components/filtering/types/SortObject';
import { OverlayInjectedProps } from 'react-bootstrap/Overlay';
import FilterInput from 'components/filtering/filter-popover/input/FilterInput';
import FilterResult from 'components/filtering/filter-popover/result/FilterResult';
import FilterButtons from 'components/filtering/filter-popover/buttons/FilterButtons';
import useFilterPopover from 'components/filtering/filter-popover/useFilterPopover';



export interface FilterPopoverProps {
	activeSortMode: SortModeEnum | null,
	filterValues: FilterValue[],
	onSearchValues: (checkedValues: unknown[]) => void,
	onAddFilterValues: (showedFilterValues: FilterValue[]) => void,
	onSorting: (mode: SortModeEnum) => void,
	onClear: () => void,
	others: OverlayInjectedProps,
}


const FilterPopover = (props: FilterPopoverProps) => {
	const { activeSortMode, onSorting } = props;
	const { show, hasDoneInitialMeasure, arrowProps, ...remainingProps } = props.others;

	const [ searchText, setSearchText, addToFilter, filteredFilterValues, filteredValuesCheckType,
		handleToggle, handleToggleAll, handleAddToFilter, handleConfirm, handleCancel, handleClear ] = useFilterPopover(props);


	return (
		<div className='grid-filter-popover' {...remainingProps} onClick={(event: MouseEvent<HTMLDivElement>) => { event.stopPropagation() }}>
			<button
				className={`filter-popover-button${activeSortMode && activeSortMode === SortModeEnum.asc ? ' active' : ''}`}
				onClick={() => onSorting(SortModeEnum.asc)}>
				<FontAwesomeIcon icon={faArrowDownAZ} />
				<p>Seřadit A - Z</p>
			</button>

			<button
				className={`filter-popover-button${activeSortMode && activeSortMode === SortModeEnum.desc ? ' active' : ''}`}
				onClick={() => onSorting(SortModeEnum.desc)}>
				<FontAwesomeIcon icon={faArrowUpZA} />
				<p>Seřadit Z - A</p>
			</button>

			<button className='filter-popover-button' onClick={handleClear}>
				<FontAwesomeIcon icon={faXmark} />
				<p>Smazat filtr</p>
			</button>

			<FilterInput
				searchText={searchText}
				onChange={setSearchText}
				onPressEnter={handleConfirm} />

			<FilterResult
				filterValues={filteredFilterValues}
				valuesCheckType={filteredValuesCheckType}
				addToFilter={addToFilter}
				showAddToFilter={searchText && searchText.length > 0 ? true : false}
				onToggleAll={handleToggleAll}
				onAddToFilter={handleAddToFilter}
				onToggle={handleToggle} />

			<FilterButtons
				disabled={!filteredFilterValues || filteredFilterValues.length === 0}
				onConfirm={handleConfirm}
				onCancel={handleCancel} />
		</div>
	);
};

export default FilterPopover;